import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { JsonHeaderInterceptor } from './json-header.interceptor';

export function provideRmaJsonHeader(): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: HTTP_INTERCEPTORS, useClass: JsonHeaderInterceptor, multi: true }]);
}
